const Monitoring = () => import('@/components/Organisations/Monitoring');
const Alerts = () => import('@/components/Organisations/Alerts');
const Dashboard = () => import('@/components/Organisations/Dashboard');

export default {
  parent: 'Dashboard',
  title: 'Dashboard',
  link: '/dashboard',
  path: '/dashboard',
  component: Dashboard,
  redirect: 'dashboard/monitoring',

  meta: {
    permission: [{ action: 'manage', entity: 'dashboard' }],
    id: 'dashboard-tab'
  },
  permission: [{ action: 'manage', entity: 'dashboard' }],
  children: [
    {
      title: 'Monitoring',
      link: '/dashboard/monitoring',
      path: 'monitoring',
      component: Monitoring,
      meta: {
        permission: [{ action: 'manage', entity: 'dashboard' }],
        id: 'dashboard__monitoring-tab'
      },
      permission: [{ action: 'manage', entity: 'dashboard' }]
    },
    {
      title: 'Alerting',
      link: '/dashboard/alerts',
      path: 'alerts',
      component: Alerts,
      meta: {
        permission: [
          { action: 'manage', entity: 'alerts' },
          { action: 'manage', entity: 'child_alerts' }
        ],
        id: 'dashboard__alerting-tab'
      },
      permission: [
        { action: 'manage', entity: 'alerts' },
        { action: 'manage', entity: 'child_alerts' }
      ]
    }
  ]
};
